'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppRegisteredUser$$anon$8(evaluator$12) {
  this.Lapp_data_AppRegisteredUser$$anon$8__f_evaluator$2 = null;
  this.Lapp_data_AppRegisteredUser$$anon$8__f_evaluator$2 = evaluator$12;
}
export { $c_Lapp_data_AppRegisteredUser$$anon$8 as $c_Lapp_data_AppRegisteredUser$$anon$8 };
$c_Lapp_data_AppRegisteredUser$$anon$8.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppRegisteredUser$$anon$8.prototype.constructor = $c_Lapp_data_AppRegisteredUser$$anon$8;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser$$anon$8() {
}
export { $h_Lapp_data_AppRegisteredUser$$anon$8 as $h_Lapp_data_AppRegisteredUser$$anon$8 };
$h_Lapp_data_AppRegisteredUser$$anon$8.prototype = $c_Lapp_data_AppRegisteredUser$$anon$8.prototype;
$c_Lapp_data_AppRegisteredUser$$anon$8.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_AppRegisteredUser$$anon$8.prototype.apply__s_Option = (function() {
  var v = this.Lapp_data_AppRegisteredUser$$anon$8__f_evaluator$2.apply__O();
  return (((typeof v) === "string") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_data_AppRegisteredUser$$anon$8.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_data_AppRegisteredUser$$anon$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppRegisteredUser$$anon$8, "app.data.AppRegisteredUser$$anon$8", ({
  Lapp_data_AppRegisteredUser$$anon$8: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_AppRegisteredUser$$anon$8 as $d_Lapp_data_AppRegisteredUser$$anon$8 };
//# sourceMappingURL=app.data.-App-Registered-User$$anon$8.js.map
